import { createStore, compose, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import { persistStore, createTransform } from "redux-persist";
import { Encrypt, Decrypt } from "../Helpers/Cryptography/Crypto";
import rootReducer from "./Reducers";

const encrypt = createTransform(
  (inboundState, key) => {
    try {
      if (!inboundState) return inboundState;
      const cryptedText = Encrypt(inboundState);
      return cryptedText;
    } catch (error) {
      console.error("Error during encryption:", error);
      return inboundState; // Return original state on error
    }
  },
  (outboundState, key) => {
    try {
      if (!outboundState) return outboundState;
      const decrypted = Decrypt(JSON.stringify(outboundState));
      return decrypted;
    } catch (error) {
      console.error("Error during decryption:", error);
      return outboundState; // Return original state on error
    }
  }
);

const store = createStore(rootReducer, {}, compose(applyMiddleware(ReduxThunk)));

// persistStore's second argument is PersistorOptions - it does not accept `transforms`,
// which is why redux-persist logged "invalid option passed to persistStore".
// NOTE: persistence is currently inert. Transforms belong to a persistConfig passed to
// persistReducer, and rootReducer is not wrapped in persistReducer, so nothing is
// persisted or rehydrated and `encrypt` below is never applied.
persistStore(store);

export default store;

// import { createStore, applyMiddleware } from "redux";
// import rootReducer from "./Reducers";
// import { persistStore, persistReducer } from "redux-persist";
// import { composeWithDevTools } from "redux-devtools-extension";
// import { encryptTransform } from "redux-persist-transform-encrypt";
// import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
// import thunk from "redux-thunk";

// const persistConfig = {
//   key: "root",
//   storage,
//   transforms: [
//     encryptTransform({
//       secretKey: "mahindra-credit-society",
//       onError: function (error: any) {
//         // Handle the error.
//         console.error("redux perisit error", error);
//       },
//     }),
//   ],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// const store = createStore(
//   persistedReducer,
//   composeWithDevTools(applyMiddleware(thunk))
// );

// const persistor = persistStore(store);

// export default store;
// export { persistor };
